import styled from 'styled-components';
import { Pin, Search, Command } from 'lucide-react';

import Button from '../../../components/Button/Button';

const ExploreSection = () => {
  return (
    <Container>
      <ContainerBox>
        <LeftDivision>
          <h6 className="manrope-semibold">Enterprise Suite</h6>

          <h4 className="manrope-semibold">
            Tackoom connects you to
            <br />
            <span>actual users seeking counseling.</span>
          </h4>

          <p className="sub-heading manrope-semibold">
            Access counseling with ease, digitally through tackoom.
          </p>

          <div className="list">
            <div className="listIconContainer">
              <span>
                <Pin />
              </span>
            </div>
            <div className="listInfo">
              <p className="manrope-regular">
                Gain more leads
              </p>
            </div>
          </div>
          <div className="list">
            <div className="listIconContainer">
              <span>
                <Search />
              </span>
            </div>
            <div className="listInfo">
              <p className="manrope-regular">
                Expand your counseling businesses
              </p>
            </div>
          </div>
          <div className="list">
            <div className="listIconContainer">
              <span>
                <Command />
              </span>
            </div>
            <div className="listInfo">
              <p className="manrope-regular">
                Partner with tackoom for more support
              </p>
            </div>
          </div>

          <Button variant="planewhite">Explore</Button>
        </LeftDivision>

        <RightDivision>
          <img
            src="https://blog.time2track.com/wp-content/uploads/sites/2/2017/06/How-I-Became-a-Mental-Health-Counselor-Later-in-Life.jpgt1493733291597ampwidth800ampnameHow-I-Became-a-Mental-Health-Counselor-Later-in-Life.jpg"
            alt=""
          />
        </RightDivision>
      </ContainerBox>
    </Container>
  );
};

export default ExploreSection;

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const ContainerBox = styled.div`
  width: 100%;
  max-width: 1150px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  overflow: hidden;

  @media (min-width: 768px) {
    border-left: 2px solid #ea5d0f;
    border-top: 2px solid #ea5d0f;
    border-bottom: 2px solid #ea5d0f;
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }
`;

const RightDivision = styled.div`
  width: 40%;
  overflow: hidden;
  img {
    @media (max-width: 768px) {
      width: 100%;
    }
    height: 100%;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

const LeftDivision = styled.div`
  /* background-color: #133e72; */
  width: 60%;
  padding: 2rem;
  color: #000000;

  @media (max-width: 768px) {
    width: 100%;
    padding-left: 0rem;
    padding: 1.5rem;
  }
  h6 {
    font-size: 1rem;
  }

  h4 {
    margin-top: 1.5rem;
    line-height: 1.1;
    font-size: 3.2rem;
    span {
      color: #ea5d0f;
    }
  }
  p.sub-heading {
    margin: 1rem 0;
  }

  .list {
    margin: 0.2rem 0rem;
    display: flex;
  }
  .listIconContainer {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    svg {
      margin-top: 0.25rem;
      opacity: 0.5;
      height: 0.85rem;
      width: 0.85rem;
    }
  }
  .listInfo {
    padding-left: 0.5rem;
    display: flex;
    flex-direction: column;
    p {
      font-size: 0.8rem;
    }
  }
`;
